export default __webpack_public_path__ + "static/media/partners4.d7383e5f.png";